import { render, staticRenderFns } from "./RemanejamentoLeads.vue?vue&type=template&id=8ab1cd4c&scoped=true&"
import script from "./RemanejamentoLeads.vue?vue&type=script&lang=js&"
export * from "./RemanejamentoLeads.vue?vue&type=script&lang=js&"
import style0 from "./RemanejamentoLeads.vue?vue&type=style&index=0&id=8ab1cd4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab1cd4c",
  null
  
)

export default component.exports